import React from 'react';
import T from 'i18n';
import Grid from '@mui/material/Unstable_Grid2';
import { Autocomplete, TextField, Box, Typography } from '@mui/material';

export default ({
  isAnnotation,
  filterCategory,
  setFilters,
}: {
  isAnnotation: boolean;
  filterCategory: null | any;
  setFilters: (newFilterCategory: any) => void;
}) => {
  const handleToggle = (e: { target: { name: string; checked: any } }) => {
    if (e.target.name === 'withAnnotations' || e.target.name === 'withoutAnnotations') {
      const newFilterCategory = {
        ...filterCategory,
        withoutAnnotations: false,
        withAnnotations: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (e.target.name === 'shared' || e.target.name === 'notShared') {
      const newFilterCategory = {
        ...filterCategory,
        shared: false,
        notShared: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (e.target.name === 'public' || e.target.name === 'private') {
      const newFilterCategory = {
        ...filterCategory,
        private: false,
        public: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (
      e.target.name === 'withPublicHyperlinks' ||
      e.target.name === 'withoutPublicHyperlinks'
    ) {
      const newFilterCategory = {
        ...filterCategory,
        withPublicHyperlinks: false,
        withoutPublicHyperlinks: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (e.target.name === 'withFlag' || e.target.name === 'noFlag') {
      const newFilterCategory = {
        ...filterCategory,
        withFlag: false,
        noFlag: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (e.target.name === 'withMerged' || e.target.name === 'notMerged') {
      const newFilterCategory = {
        ...filterCategory,
        withMerged: false,
        notMerged: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else if (e.target.name === 'withMerged' || e.target.name === 'notMerged') {
      const newFilterCategory = {
        ...filterCategory,
        withMerged: false,
        notMerged: false,
        [e.target.name]: e.target.checked,
      };
      setFilters(newFilterCategory);
    } else {
      const newFilterCategory = { ...filterCategory, [e.target.name]: e.target.checked };
      setFilters(newFilterCategory);
    }
  };

  return (
    <>
      <Grid xs={12}>
        {!isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.annotationsFilter')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'withoutAnnotations', label: T.translate('filters.withoutAnnotations') },
                { value: 'withAnnotations', label: T.translate('filters.withAnnotations') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.withAnnotations
                  ? { value: 'withAnnotations', label: T.translate('filters.withAnnotations') }
                  : filterCategory?.withoutAnnotations
                    ? { value: 'withoutAnnotations', label: T.translate('filters.withoutAnnotations') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'withAnnotations') {
                    handleToggle({ target: { name: 'withAnnotations', checked: true } });
                  } else if (value === 'withoutAnnotations') {
                    handleToggle({ target: { name: 'withoutAnnotations', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'withAnnotations', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
        {!isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.hyperlinksFilter')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'withoutPublicHyperlinks', label: T.translate('filters.withoutPublicHyperlinks') },
                { value: 'withPublicHyperlinks', label: T.translate('filters.withPublicHyperlinks') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.withoutPublicHyperlinks
                  ? { value: 'withoutPublicHyperlinks', label: T.translate('filters.withoutPublicHyperlinks') }
                  : filterCategory?.withPublicHyperlinks
                    ? { value: 'withPublicHyperlinks', label: T.translate('filters.withPublicHyperlinks') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'withPublicHyperlinks') {
                    handleToggle({ target: { name: 'withPublicHyperlinks', checked: true } });
                  } else if (value === 'withoutPublicHyperlinks') {
                    handleToggle({ target: { name: 'withoutPublicHyperlinks', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'withPublicHyperlinks', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
        {isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.sharingFilter')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'notShared', label: T.translate('filters.privateAnnotations') },
                { value: 'shared', label: T.translate('filters.sharedAnnotations') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.notShared 
                  ? { value: 'notShared', label: T.translate('filters.privateAnnotations') }
                  : filterCategory?.shared 
                    ? { value: 'shared', label: T.translate('filters.sharedAnnotations') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'shared') {
                    handleToggle({ target: { name: 'shared', checked: true } });
                  } else if (value === 'notShared') {
                    handleToggle({ target: { name: 'notShared', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'shared', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
        {!isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.visibility')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'private', label: T.translate('filters.privateOnly') },
                { value: 'public', label: T.translate('filters.publicOnly') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.private 
                  ? { value: 'private', label: T.translate('filters.privateOnly') }
                  : filterCategory?.public 
                    ? { value: 'public', label: T.translate('filters.publicOnly') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'private') {
                    handleToggle({ target: { name: 'private', checked: true } });
                  } else if (value === 'public') {
                    handleToggle({ target: { name: 'public', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'private', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
        {!isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.flag')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'noFlag', label: T.translate('filters.noFlag') },
                { value: 'withFlag', label: T.translate('filters.withFlag') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.noFlag 
                  ? { value: 'noFlag', label: T.translate('filters.noFlag') }
                  : filterCategory?.withFlag 
                    ? { value: 'withFlag', label: T.translate('filters.withFlag') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'withFlag') {
                    handleToggle({ target: { name: 'withFlag', checked: true } });
                  } else if (value === 'noFlag') {
                    handleToggle({ target: { name: 'noFlag', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'withFlag', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
        {!isAnnotation && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography sx={{ minWidth: 120, marginRight: '1.8rem', fontWeight: '600' }}>
              {T.translate('filters.merged')}
            </Typography>
            <Autocomplete
              size="small"
              clearOnEscape
              options={[
                { value: 'notMerged', label: T.translate('filters.notMerged') },
                { value: 'withMerged', label: T.translate('filters.withMerged') }
              ]}
              getOptionLabel={(option) => option.label}
              value={
                filterCategory?.notMerged 
                  ? { value: 'notMerged', label: T.translate('filters.notMerged') }
                  : filterCategory?.withMerged 
                    ? { value: 'withMerged', label: T.translate('filters.withMerged') }
                    : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  const value = newValue.value;
                  if (value === 'withMerged') {
                    handleToggle({ target: { name: 'withMerged', checked: true } });
                  } else if (value === 'notMerged') {
                    handleToggle({ target: { name: 'notMerged', checked: true } });
                  }
                } else {
                  handleToggle({ target: { name: 'withMerged', checked: false } });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" size="small" />
              )}
              sx={{ flex: 1 }}
            />
          </Box>
        )}
      </Grid>
    </>
  );
};
